import "../assets/Dialog.css";
import { jsxs as d, jsx as a } from "preact/jsx-runtime";
import { useRef as w, useImperativeHandle as _, useEffect as v } from "preact/hooks";
import { forwardRef as h } from "preact/compat";
import { c as y } from "./index.2w0W-O47.js";
import { B as C } from "./Button.B39sLJB4.js";
import { l as k } from "./Icon.CPrkqxma.js";
const O = "_dialog_3nwcy_7", b = "_fullScreenOnDesktop_3nwcy_63", D = "_dialogHeader_3nwcy_89", E = "_dialogCloseButton_3nwcy_104", B = "_dialogContent_3nwcy_109", n = {
  dialog: O,
  fullScreenOnDesktop: b,
  dialogHeader: D,
  dialogCloseButton: E,
  dialogContent: B
}, N = h(
  ({ children: p, fullScreenOnDesktop: u = !1, headerContent: g, ...i }, f) => {
    const t = w(null), s = () => {
      var e, o;
      (e = t.current) == null || e.close(), (o = window.history.state) != null && o.dialogOpen && window.history.back();
    }, l = (e) => {
      e.target === t.current && s();
    };
    return _(f, () => t.current), v(() => {
      const e = t.current, o = () => {
        e.open && s();
      }, r = new MutationObserver((m) => {
        m.forEach((c) => {
          c.type === "attributes" && c.attributeName === "open" && (e.open ? (window.history.pushState({ dialogOpen: !0 }, ""), window.addEventListener("popstate", o)) : (window.history.replaceState({ dialogOpen: !1 }, ""), window.removeEventListener("popstate", o)));
        });
      });
      return e.addEventListener("click", l), r.observe(e, { attributes: !0 }), () => {
        r.disconnect(), window.removeEventListener("popstate", o), e.removeEventListener("click", l);
      };
    }, []), /* @__PURE__ */ d(
      "dialog",
      {
        ref: t,
        ...i,
        "aria-modal": "true",
        class: y(n.dialog, i.class, {
          [n.fullScreenOnDesktop]: u
        }),
        "data-testid": "pulse-dialog",
        children: [
          /* @__PURE__ */ d("header", { class: n.dialogHeader, children: [
            g,
            /* @__PURE__ */ a(
              C,
              {
                "data-testid": "pulse-dialog-close-button",
                text: "Dialog schließen",
                class: n.dialogCloseButton,
                level: "secondary",
                iconOnly: !0,
                iconComponent: /* @__PURE__ */ a(k, {}),
                onClick: s
              }
            )
          ] }),
          /* @__PURE__ */ a("section", { class: n.dialogContent, children: p })
        ]
      }
    );
  }
);
export {
  N as D
};
